<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
      <section id="ngx-datatable-kitchen-sink">
        <div class="card">
          <div class="card-header">
            <h4 class="card-title">{{ 'MENU.DASHBOARD.cities' | translate }}</h4>
            <!-- <button class="btn btn-primary" (click)="addCoupon()">
              Add Employees
            </button> -->
          </div>
          <div class="card-body">
            <p class="card-text"> {{ 'MENU.DASHBOARD.cities_list' | translate }}</p>
          </div>
        </div>
  
        <div class="row d-flex justify-content-between">
          <div class="col-md-2 col-sm-12 mb-1 mb-md-0">
            <div class="form-group ">
              <label for="itemsPerPage" 
              style="margin-right: 23px !important"

               [ngClass]="{ 'ar-label': translate.currentLang === 'ar' }"
               >{{ 'MENU.DASHBOARD.show' | translate }}</label>
              <div class="d-flex align-items-center "
              [ngClass]="{ 'ar-select': translate.currentLang === 'ar' }">
                <select
                  id="itemsPerPage"
                  class="form-control form-control-sm mr-2" 
                  [(ngModel)]="itemsPerPage"
                  
                >
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
                <span>{{ 'MENU.DASHBOARD.entries' | translate }}</span>
              </div>
            </div>
          </div>

          <!-- Country Filter -->
<div class="col-md-3 col-sm-12 mb-1 mb-md-0">
  <div class="form-group">
    <label 
      class="mr-2"
      [ngClass]="{ 'ar-label': translate.currentLang === 'ar' }"
    >
      {{ 'MENU.DASHBOARD.country' | translate }}
    </label>

    <select
      class="form-control"
      [(ngModel)]="selectedCountryId"
      (change)="onCountryChange()"
    >
      <option value="all">
        {{ 'MENU.DASHBOARD.all_countries' | translate }}
      </option>

      <option 
        *ngFor="let country of countries" 
        [value]="country.id"
      >
        {{  country.name  }}
      </option>
    </select>
  </div>
</div>

          <!-- <div class="col-md-6 col-sm-12">
            <div class="form-group">
              <label for="searchInput" class="mr-2">{{ 'MENU.DASHBOARD.search' | translate }}</label>
              <input
                id="searchInput"
                type="search"
                placeholder="{{ 'MENU.DASHBOARD.search' | translate }}"
                class="form-control form-control-sm"
                (keyup)="filterUpdate($event)"
                (search)="filterUpdate($event)"
              />
            </div> 
          </div> -->
        </div>
  
        <ngx-datatable 
        [rows]="cities"
        [rowHeight]="58"
        class="bootstrap core-bootstrap bg-white"
        [limit]="itemsPerPage"
        [columnMode]="ColumnMode.force"
        [headerHeight]="40"
        [footerHeight]="50"
        [scrollbarH]="true"
        [messages]="messages"
      >
        <ngx-datatable-column
          name="{{ 'MENU.DASHBOARD.id' | translate }}"
          prop="id"
          [width]="20"
        ></ngx-datatable-column>
        


        <ngx-datatable-column
          name="{{ 'MENU.DASHBOARD.name' | translate }}"
          prop="name_ar"
          [width]="100"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ row.name }}
          </ng-template>
        </ngx-datatable-column>
 <!-- <ngx-datatable-column
          name="{{ 'MENU.DASHBOARD.name' | translate }}"
          prop="name_en"
          [width]="100"
        >
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ row.name_en }}
          </ng-template>
        </ngx-datatable-column> -->
   
       


    
  <!-- Actions -->
 <ngx-datatable-column name="{{ 'MENU.DASHBOARD.investor_actions' | translate }}" prop="actions" [flexGrow]="1" [sortable]="false">
  <ng-template ngx-datatable-cell-template let-row="row">
    <div class="d-flex align-items-center">
      <div ngbDropdown container="body" class="btn-group">
        <button
          ngbDropdownToggle
          type="button"
          class="btn btn-sm btn-icon dropdown-toggle hide-arrow"
          [id]="'dropdownActions_' + row.id"
        >
          <i data-feather="more-vertical"></i>
        </button>

        <div
          ngbDropdownMenu
          class="dropdown-menu dropdown-menu-right"
          [attr.aria-labelledby]="'dropdownActions_' + row.id"
        >

                   
 
    
      <button
        class="dropdown-item w-100"
        ngbDropdownItem
        (click)="editCity(row.id)"
      >
        <i data-feather="edit" class="mr-50 mx-2"></i>
        {{ 'MENU.DASHBOARD.investor_edit' | translate }}
      </button>

          <button
            class="dropdown-item text-danger w-100"
            ngbDropdownItem
            (click)="deleteCity(row.id)"
          >
            <i data-feather="trash" class="mr-50 mx-2"></i>
             {{ 'MENU.DASHBOARD.investor_delete' | translate }}
          </button>
        </div>
      </div>
    </div>
  </ng-template>
</ngx-datatable-column> 



      </ngx-datatable>
       
      </section>
    </div>
  </div>